var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "awaitingTickets" } },
    [
      _c("supsis-table", {
        attrs: {
          columns: _vm.columns(),
          rows: _vm.waitingChatGetter,
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
      }),
      _vm._v(" "),
      _vm.showingTicket
        ? _c("AwaitingTicketDetails", {
            attrs: {
              ticket: _vm.showingTicket,
              statusList: _vm.statuses,
              "change-ticket-status": _vm.handleChangeStatus,
            },
            on: {
              close: function ($event) {
                _vm.showingTicket = null
              },
              confirm: _vm.sendResponse,
              sendAsComment: _vm.sendAsComment,
              deleteComment: _vm.deleteComment,
              changeHideStatusIGComment: _vm.changeHideStatusIGComment,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }